import React from "react";
import styles from "./ExportSurvey.module.css";
import TextLink from "../../common/components/textLink/TextLink";
import DownloadIcon from "../../common/components/icons/DownloadIcon";


export default function ExportSurvey() {

    return (
        <>
            <div className={styles.exportButton}>
                <TextLink
                    href={"/api/exportSurvey"}
                    icon={<DownloadIcon size={20}/>}
                    download
                >
                    アンケート結果を出力
                </TextLink>
            </div>
        </>
    );
}
